<template>
    <div class="documentation-data">
        <ul class="sub-navigation">
            <template v-if="documentView == 'documentList'">
                <li><h1>文档中心</h1></li>
                <li @click="linkTo(doc)" v-for="(doc, index) in docList" :key="index">
                    <p :class="[currentId == doc.id && 'active']">{{doc.title}}</p>
                </li>
            </template>
            <template v-else>
                <li class="detail" @click="back"><i class="iconfont icon-chexiao"></i> 文档详情</li>
            </template>
        </ul>
        <component :is="documentView" ></component>
    </div>
</template>

<script>
import documentList from '@/components/documentation/list'
import documentDetail from '@/components/documentation/detail'
export default {
    data(){
        return {
            menu: true,
            currentId: null,
            docList: []
        }
    },
    components: {
      documentList,
      documentDetail
    },
    beforeRouteEnter: (to, from, next) => {
        next();
    },
    computed: {
      documentView: {
        get(){
          let store = this.$store.state.docStore.documentation
          return store.componentName
        }
      }
    },
    watch: {
        '$route'(to, from){
            this.toggleRoute(to.name)
        }
    },
    mounted(){
        this.getDocCateList();
        this.toggleRoute(this.$router.currentRoute.name)
    },
    methods:{
        toggleRoute( name ){
            if(name == 'doc_detail'){
                this.menu = false
            } else {
                this.menu = true
            }
        },
        linkTo( item ){
            this.currentId =item.areaCode;
            this.getDocListById(this.currentId)
        },
        back(){
            this.$store.commit('documentationData', {
              componentName: 'documentList',
              id: ''
            })
        },
        async getDocCateList(){
            // this.$store.commit('updateOutComponentLoading', true)
            let result = await this.$http.get('api/help/index')
            // console.log(result)
            this.docList = result.data;
            if(result.length){
                this.currentId = result[0].id;
                this.getDocListById(this.currentId)
            }
        },
        async getDocListById(id){
            let result = await this.$http.get('/api/help/index', { type: 1, deviceType: id});
            // this.$store.commit('updateOutComponentLoading', false)
            if(result){
                this.$store.commit('docList', result.data)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .documentation-root{
        padding-top:20px;
        padding-right: 50px;
        margin-left: 320px;
        .table-center{
            text-align: center;
        }
        .table-base tr:nth-child(2n){
            background: #fff;
        }
        .table-base tr:nth-child(2n+1){
            background: #d4edfa;
        }
        .documentation_container{
            min-height: 749px;
            margin-bottom: 20px;
        }
    }
    .documentation-data{
        min-height: 100%;
        border-top: 1px solid transparent;
        .sub-navigation{
            width: 320px;
            top:100px;
            background: #fff;
             border-right:1px solid #ccc ;
            li{
                line-height: 1;
                height: auto;
                color: #2c3e50;
                border-bottom:1px solid #ccc ;
            }
            li:hover{
                background:#ccc;
            }
            h1{
                font-size:17px;
                color: #2c3e50;
                font-weight: normal;
                height: 56px;
                line-height: 56px;
            }
            p{
                line-height: 40px;
            }
            p:hover{
                background: #4c586c;
            }
            p.active{
                background:#f0f3fb;
                color: #354052;
            }
            .detail{
                line-height: 57px;
                font-size: 17px;
            }
        }
        .table-base tr td{
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/component/base-documentation1.vue